module.exports = __webpack_public_path__ + "static/img/GB@2x.5af3eeb4.jpg";